import { useState } from "react";
import { Tags } from "lucide-react";
import Sidebar from "@/components/sidebar.jsx";
import MobileMenuButton from "@/components/ui/mobile-menu-button.jsx";
import PageHeader from "@/components/page-header.jsx";
import PageHeaderActions from "@/components/page-header-actions.jsx";
import DowntimeClassificationPanels from "@/components/downtime-classification/downtime-classification-panels.jsx";

/**
 * Downtime Classification page component.
 * Lets users map 3rd-party downtime reasons to Mechanical / Non-Mechanical and
 * override source-provided classifications.
 * @returns {JSX.Element} Downtime Classification page with sidebar and header
 */
export default function DowntimeClassification() {
  /** @type {[boolean, Function]} */
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className='flex h-screen bg-background relative'>
      {/* Mobile menu button */}
      <MobileMenuButton
        isOpen={isMobileMenuOpen}
        onToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      {/* Sidebar */}
      <Sidebar
        key='persistent-sidebar'
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {/* Main Content - min-h-0 so flex child can shrink and show scrollbar */}
      <div className='flex-1 flex flex-col min-h-0 overflow-hidden transition-all duration-200 ease-in-out'>
        <PageHeader
          icon={Tags}
          title='Downtime Classification'
          subtitle="Map 3rd-party downtime reasons to Mechanical / Non-Mechanical, and override source-provided classifications when a provider's labelling is wrong.">
          <PageHeaderActions />
        </PageHeader>

        {/* Main Content - scrollable region */}
        <div className='flex-1 min-h-0 overflow-y-auto overflow-x-hidden p-4 sm:p-6'>
          <DowntimeClassificationPanels />
        </div>
      </div>
    </div>
  );
}
